import { render } from "./Project.vue?vue&type=template&id=616c7aed&scoped=true"
import script from "./Project.vue?vue&type=script&lang=js"
export * from "./Project.vue?vue&type=script&lang=js"

import "./Project.vue?vue&type=style&index=0&id=616c7aed&lang=scss"
import "./Project.vue?vue&type=style&index=1&id=616c7aed&lang=scss&scoped=true"

import exportComponent from "/home/callum/Documents/CODE/raphaelschoen/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-616c7aed"]])

export default __exports__